import { createContext } from 'react'

const RadioGroupContext = createContext()

export default RadioGroupContext
